import API from "./API";

export default class PaymentParametersAPI extends API {
  constructor(parameters = {}) {
    super("/PaymentParameters", parameters);
  }
}
